import React, { useEffect, useState } from 'react';
import { AlertTriangle, Clock } from 'lucide-react';
export function UrgencyBar() {
  // Start with 2 hours, 14 minutes, 37 seconds for a realistic "limited time" feel
  const [timeLeft, setTimeLeft] = useState(2 * 3600 + 14 * 60 + 37);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="sticky top-0 z-50 w-full bg-text-primary text-white py-3 px-4 shadow-md" data-id="element-225">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-sm sm:text-base font-medium text-center" data-id="element-226">
        <div className="flex items-center gap-2 text-accent" data-id="element-227">
          <AlertTriangle size={18} className="animate-pulse" data-id="element-228" />
          <span data-id="element-229">
            ATENCIÓN: Descuento de lanzamiento disponible solo por tiempo
            limitado
          </span>
        </div>
        <div className="flex items-center gap-2 bg-white/10 px-3 py-1 rounded-full font-mono text-accent" data-id="element-230">
          <Clock size={16} data-id="element-231" />
          <span className="font-bold tracking-wider" data-id="element-232">
            {formatTime(timeLeft)}
          </span>
        </div>
      </div>
    </div>;
}